<template>
  <div>
    <el-select
        v-model="selectedVerificationMethod"
        placeholder="Choose..."
        class="verification-method-select"
        @change="notifyParent">
      <el-option
          v-for="allowedMethod in allowedVerificationMethods"
          :key="allowedMethod.value"
          :label="allowedMethod.label"
          :value="allowedMethod.value">
        <span class="option-container">
          <div class="option-icon-container ">
            <img
                style="vertical-align:middle"
                :src="getIcon(allowedMethod)">
          </div>
          <span class="select-label">{{ allowedMethod.label }} </span>
        </span>
        <span
            v-if="allowedMethod.value === selectedVerificationMethod"
            style="float: right; color: #8492a6; font-size: 13px">
          <img
              class="check-img"
              :src="icons.check">

        </span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import axios from "axios";
import { createNamespacedHelpers as module } from "vuex";

const { mapGetters: accountGetters } = module("db/account");

export default {
  name: "VerificationMethodSelect",
  emits: ["methodSelected", "verificationChannelsUpdated"],
  inject: ["VERIFICATION_METHODS", "ICONS"],
  data() {
    return {
      selectedVerificationMethod: null,
      allowedVerificationMethods: [],
      icons: {
        check: require("@/assets/icons/new-ui/customer/authorizations/shared/check.svg"),
      },
      image: {
        background:
          'url("/static/img/action-account-verification.8622284.svg") no-repeat scroll 7px 7px',
        paddingLeft: "40px",
      },
    };
  },
  computed: {
    ...accountGetters(["customerId"]),
    ...accountGetters(["verificationChannels"]),
  },
  mounted() {
    this.initialize(this.verificationChannels);
  },
  methods: {
    initialize(verificationChannels) {
      if (verificationChannels && verificationChannels.length > 0) {
        this.allowedVerificationMethods = verificationChannels;

        let smsMethod = (this.selectedVerificationMethod =
          this.allowedVerificationMethods.filter(
            (method) => method.value === "sms"
          ));

        if (smsMethod.length > 0) {
          this.selectedVerificationMethod = smsMethod[0].value;
        } else {
          this.selectedVerificationMethod =
            this.allowedVerificationMethods[0].value;
        }

        this.notifyParent();
      }
    },
    notifyParent() {
      this.updateSelectedMethodIcon();
      this.$emit("methodSelected", this.selectedVerificationMethod);
      this.$emit(
        "verificationChannelsUpdated",
        this.allowedVerificationMethods
      );
    },
    getIcon(allowedMethod) {
      if (!allowedMethod) {
        return null;
      }

      return this.ICONS[allowedMethod.value];
    },
    updateSelectedMethodIcon() {
      let selectedMethodText = document.querySelector(
        ".el-input.el-input--suffix .el-input__inner"
      );

      const iconName = this.selectedVerificationMethod;
      selectedMethodText.style.background = `url(${this.ICONS[iconName]}) no-repeat scroll 7px center`;
      selectedMethodText.style.paddingLeft = "40px";
    },
  },
};
</script>

<style scoped>
.option-container {
  float: left;
}

.option-icon-container {
  display: inline-block;
  margin-right: 15px;
  width: 25px;
  text-align: center;
}

.check-img {
  width: 16px;
  height: 12px;
}

li.selected .select-label {
  color: #1476ad;
}

.select-label {
  width: 216px;
  height: 24px;

  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
}

.el-select {
  width: 228px;
  height: 48px;
}
</style>

<style>
div.el-select.verification-method-select {
  width: 280px;
  padding-right: 0;
}

.el-select.verification-method-select .el-input .el-input__inner {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #424242;

  border: 1px solid #81919f;
  border-radius: 4px;
  width: 280px;
  height: 48px;
}

.el-select.verification-method-select .el-input .el-select__caret {
  color: #424242;
  font-weight: 300;
}

.el-popup-parent--hidden .v-modal {
  opacity: 0.8;
}

.el-input__suffix {
  display: flex;
  padding-right: 0px;
  margin-right: 10px;
}

.el-dialog {
  border-radius: 4px !important;
}
</style>
